import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { getSeverityByStatusCode, getStatusClass } from '../functions/app-insights-functions';
import { AppInsightsService } from '../services/app-insights/app-insights.service';

@Injectable()
export class AppInsightsInterceptor implements HttpInterceptor {
  private appInsightsService = inject(AppInsightsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          //track trace if any request fails
          // statusClass is computed by getStatusClass so a client timeout is distinguishable from a
          // network-down failure (both carry status 0) — see AC2 on PBI 54129.
          this.appInsightsService.trackTrace('ApiError', getSeverityByStatusCode(err.status), {
            method: req.method,
            status: err.status || 0,
            statusClass: getStatusClass(err),
          });
        },
      })
    );
  }
}
